export const InjectStyles = () => {
  return (
    <link
      rel="stylesheet"
      type="text/css"
      href="https://cdn.privacytools.com.br/public_api/banner/style/5ZdG1241.css?t=1"
    />
  )
}
